"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTypeEnum = void 0;
var OrderTypeEnum;
(function (OrderTypeEnum) {
    OrderTypeEnum["Paid"] = "Paid";
    OrderTypeEnum["Complimentary"] = "Complimentary";
    OrderTypeEnum["RSVP"] = "RSVP";
    OrderTypeEnum["Season"] = "Season";
    OrderTypeEnum["Shared"] = "Shared";
})(OrderTypeEnum = exports.OrderTypeEnum || (exports.OrderTypeEnum = {}));
;
//# sourceMappingURL=IOrderType.js.map